import { render, staticRenderFns } from "./ReceiveNumbers.vue?vue&type=template&id=2e5d3635&scoped=true&"
import script from "./ReceiveNumbers.vue?vue&type=script&lang=js&"
export * from "./ReceiveNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveNumbers.vue?vue&type=style&index=0&id=2e5d3635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d3635",
  null
  
)

export default component.exports